module.exports = __webpack_public_path__ + "static/media/CloseIcon.229e6e13.svg";